<template>
	<TemplateDefault v-bind="props">
		<slot />
	</TemplateDefault>
</template>

<script lang="ts" setup>
import type { BreadcrumbsType } from '#base/core/types/BreadcrumbsType';

const props = defineProps<{
	pageTitle?: string;
	breadcrumbs?: BreadcrumbsType;
	isSales?: boolean;
}>();
</script>
